import { render } from "./EditTemplateDialog.vue?vue&type=template&id=104767d3&scoped=true"
import script from "./EditTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditTemplateDialog.vue?vue&type=script&lang=js"

import "./EditTemplateDialog.vue?vue&type=style&index=0&id=104767d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104767d3"]])

export default __exports__